package com.shadowings.gero.data.lessons.chapter13

import com.shadowings.gero.data.lessons.inlineMeaning
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.lessons.buildVocabQuizContent
import com.shadowings.gero.data.lessons.chapter12.buildMultiPress
import com.shadowings.gero.data.lessons.toHieroExplanation
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_parole_di_luoghi_1
import gero.composeapp.generated.resources.exp_content_word_reading_and_meaning
import gero.composeapp.generated.resources.exp_title_parole_di_luoghi
import gero.composeapp.generated.resources.exp_title_word_name

val paroleDiLuoghiWordIds = listOf("TRONO", "COLLINA", "ORIZZONTE", "TETTO")

fun getParoleDiLuoghiContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IExplanation> {
    val intro = listOf(
        ExplanationContent(
            title = Res.string.exp_title_parole_di_luoghi,
            content = Res.string.exp_content_parole_di_luoghi_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        )
    )

    val hieroSlide = listOf("G25").toHieroExplanation(hiero, languageCode)

    val wordSlides = paroleDiLuoghiWordIds
        .mapNotNull { id -> words.firstOrNull { it.id == id } }
        .map { word ->
            ExplanationContent(
                title = Res.string.exp_title_word_name,
                titleArgs = listOf(word.getMeaning(languageCode)),
                content = Res.string.exp_content_word_reading_and_meaning,
                contentArgs = listOf(
                    word.reading,
                    word.inlineMeaning(languageCode),
                    word.getNote(languageCode)
                ),
                face = Faces.Happy,
                character = Characters.Nilo,
                composable = { MdCWord(word.gardiner, rtl = false, cart = false, size = 96.dp) },
                wordId = word.id
            )
        }

    return intro + hieroSlide + wordSlides
}

private val paroleDiLuoghiOldWordIds = listOf("CASA", "TEMPIO", "ALTARE", "TOMBA")

fun getParoleDiLuoghiQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val explanations = getParoleDiLuoghiContent(hiero, words, languageCode)

    val baseQuizzes = buildVocabQuizContent(
        explanations = explanations,
        words = words,
        languageCode = languageCode,
        additionalOptions = paroleDiLuoghiOldWordIds.toSet()
    )

    val newWords = paroleDiLuoghiWordIds.mapNotNull { id -> words.firstOrNull { it.id == id } }
    val oldWords = paroleDiLuoghiOldWordIds.mapNotNull { id -> words.firstOrNull { it.id == id } }

    val multiPressNew = buildMultiPress(newWords.shuffled(), languageCode)
    val multiPressMixed = buildMultiPress(
        (newWords.shuffled().take(2) + oldWords.shuffled().take(2)).shuffled(),
        languageCode
    )

    return (baseQuizzes + multiPressNew + multiPressMixed).shuffled()
}
